module.exports = __webpack_public_path__ + "791654a19a6e85d7c3c23a732bf7a823.svg";